import { Converter } from '../types/converter';

export const electricConductivityConverter: Converter = {
  id: 'electricConductivity',
  name: 'Electric Conductivity Converter',
  icon: 'Zap',
  categories: ['electricity'],
  units: [
    // Base SI unit
    { name: 'Siemens/meter', symbol: 'S/m', factor: 1 },
    { name: 'Picosiemens/meter', symbol: 'pS/m', factor: 1e-12 },
    
    // Historical units
    { name: 'Mho/meter', symbol: 'mho/m', factor: 1 },
    { name: 'Mho/centimeter', symbol: 'mho/cm', factor: 100 },
    
    // CGS units
    { name: 'Abmho/meter', symbol: 'abmho/m', factor: 1e9 },
    { name: 'Abmho/centimeter', symbol: 'abmho/cm', factor: 1e11 },
    { name: 'Statmho/meter', symbol: 'stmho/m', factor: 1.112650e-12 },
    { name: 'Statmho/centimeter', symbol: 'stmho/cm', factor: 1.112650e-10 }
  ]
};
